import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Modal, Form } from "react-bootstrap";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup"; // ✅ Yup for form validation
import MainHeader from "../../Pages/Header/HeaderForBus";
import FooterStyle from '../../Pages/Footer/Footer';
import API from '../../Api/Api';
import { IMAGE_PATHS, DOMAIN_URL } from '../../Functions/Constant';
import ProfilePhotoPopup from '../../Components/ProfilePhotoPopup'
import ConfirmationPopup from '../../Components/ConfirmationPopup'
import Confin from '../../Components/confin'
import ButtonsVariant from '../../Components/Button/ButtonVariant';
// import firebase from 'firebase/app';
// import 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithPhoneNumber, RecaptchaVerifier } from 'firebase/auth';
import { getCountries, getCountryCallingCode } from 'libphonenumber-js';
import Select from 'react-select';
import countries from 'i18n-iso-countries';
import './ProfilePage.css';
import Loader from "../../Components/Loader";
import axios from 'axios';
// Register i18n-iso-countries English locale
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));


// Firebase Configuration
const firebaseConfig = {
    apiKey: "AIzaSyA2P9-Fhbu_1CBKYR2YuHyWPZO_4euTs_s",
    authDomain: "phoneverification-6a78e.firebaseapp.com",
    projectId: "phoneverification-6a78e",
    storageBucket: "phoneverification-6a78e.firebasestorage.app",
    messagingSenderId: "315297057884",
    appId: "1:315297057884:web:0f944fcb3e8b13e9146a99"
};

/// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Generate country code options using libphonenumber-js and i18n-iso-countries
const countryCodeOptions = getCountries()
    .map(country => ({
        value: `+${getCountryCallingCode(country)}`,
        label: `+${getCountryCallingCode(country)} (${countries.getName(country, 'en') || country})`
    }))
    .sort((a, b) => {
        // Prioritize United States (+1) at the top, then sort alphabetically
        if (a.value === "+1") return -1;
        if (b.value === "+1") return 1;
        return a.label.localeCompare(b.label);
    });
const getCountryCodeFromNetwork = async () => {
    try {
        // Step 1: Fetch client's public IP address
        const ipResponse = await axios.get('https://api.ipify.org?format=json');
        const ip = ipResponse.data.ip;

        if (!ip) {
            console.warn("No IP address found, defaulting to +1");
            return "+1";
        }

        // Step 2: Query ipapi.co with the IP
        const geoResponse = await axios.get(`https://ipapi.co/${ip}/json`);
        const { country_code } = geoResponse.data; // ISO 3166-1 alpha-2 (e.g., "IN", "US")

        if (country_code) {
            // Map country code to phone country code
            const phoneCountryCode = `+${getCountryCallingCode(country_code)}`;
            if (countryCodeOptions.find(option => option.value === phoneCountryCode)) {
                return phoneCountryCode;
            } else {
                console.warn(`Country code ${country_code} not supported in countryCodeOptions, defaulting to +1`);
                return "+1";
            }
        } else {
            console.warn("No country code found from ipapi.co, defaulting to +1");
            return "+1";
        }
    } catch (error) {
        console.error("Error fetching geolocation from ipapi.co:", error);
        return "+1"; // Fallback on error
    }
};

const AccountSettings = () => {
    const [profilePic, setProfilePic] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [imageError, setImageError] = useState("");
    const [locationquery, setLocationquery] = useState("");
    const [locationsuggestions, setLocationSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);
    const [formValues, setFormValues] = useState({
        name: "",
        phone: "",
        email: "",
        city: "",
        gender: "0",
        //profileTitle: "",
        countryCode: "+1" // Default to +1 (United States)
    });
    const [popupData, setPopupData] = useState({
        isOpen: false,
        title: "",
        message: "",
        onClose: () => { },
        onConfirm: () => { }
    });

    const [showOTPModal, setShowOTPModal] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [otp, setOtp] = useState("");
    const [confirmationResult, setConfirmationResult] = useState(null);
    const [otpError, setOtpError] = useState("");
    // New state to track phone verification status
    const [isPhoneVerified, setIsPhoneVerified] = useState(true); // Initially true for existing phone number
    const [originalPhone, setOriginalPhone] = useState(""); // Store original phone number for comparison
    const [countryCode, setCountryCode] = useState("+1"); // Track selected country code
    // Add state to track the temporary country code selection
    const [tempCountryCode, setTempCountryCode] = useState(formValues.countryCode);
    // Initialize reCAPTCHA verifier
    useEffect(() => {
        window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
            size: 'invisible',
            callback: () => { }
        });
    }, [auth]);

    // ✅ Validation Schema using Yup
    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .matches(/^[A-Za-z\s]+$/, "Only alphabets are allowed")
            .required("Name is required"),
        phone: Yup.string()
            .matches(/^[0-9]{1,20}$/, "Only numbers allowed (Max 20 digits)")
            .required("Phone number is required"),
        countryCode: Yup.string()
            .required("Country code is required")
            .oneOf(countryCodeOptions.map(option => option.value), "Select a valid country code"),
        // email: Yup.string().email("Invalid email format").required("Email is required"),
        city: Yup.string().required("Location is required"),
        gender: Yup.string().required("Gender is required"),
        // profileTitle: Yup.string()
        //     .matches(/^[A-Za-z\s.]+$/, "Only alphabets, spaces, and periods are allowed")
        //     .required("Profile title is required")
        //     .test(
        //         "word-count",
        //         "Profile title must be 20 words or less",
        //         (value) => {
        //             if (!value) return true; // Skip if empty (required will catch it)
        //             const wordCount = value.trim().split(/\s+/).length;
        //             return wordCount <= 20;
        //         }
        //     )
    });

    // ✅ Fetch user data
    const fetchDataUser = async () => {
        try {
            const defaultCountryCode = await getCountryCodeFromNetwork();
            const res = await API.get(`/user`);
            if (res.user) {
                const fetchedCountryCode = res.user.countryCode || defaultCountryCode; // Fallback to +1
                // Log if countryCode is unsupported
                if (!countryCodeOptions.find(option => option.value === fetchedCountryCode)) {
                    console.warn(`Unsupported countryCode from backend: ${fetchedCountryCode}, defaulting to +1`);
                }
                setTempCountryCode(fetchedCountryCode); // Set the temporary country code
                setFormValues({ countryCode: fetchedCountryCode, name: res.user.name, phone: res.user.phone, email: res.user.email, city: res.user.city_id, gender: res.user.gender || "" });//, profileTitle: res.user.profile_title || ""
                if (res.user.phone && res.user.phone.length > 0) {
                    setPhoneNumber(res.user.phone);
                    setCountryCode(fetchedCountryCode);
                    setOriginalPhone(res.user.phone); // Store original phone number
                    setIsPhoneVerified(true); // Assume existing phone is verified
                } else {
                    setPhoneNumber("");
                    setIsPhoneVerified(false); // Phone is not verified if empty
                }
                setCountryCode(fetchedCountryCode);
                setSelectedCountryCodeName(countryCodeOptions.find(option => option.value === fetchedCountryCode).label); // Set the selected country code name
                setProfilePic(DOMAIN_URL + '/' + res.user.profile_image);
                if (res.user.city_name != null) {
                    setLocationquery(res.user.city_name + ', ' + res.user.state_name + ', ' + res.user.country_name);
                }

                //setFieldValue("city", res.user.city_name);
                // setValues({
                //     name: res.user.name || "",
                //     phone: res.user.phone || "",
                //     // email: res.user.email || "",
                //     city: res.user.city || "",
                // });
                //  setLocationquery(res.user.city || "");
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };
    useEffect(() => {
        fetchDataUser();
    }, []);
    // ✅ Fetch city suggestions from API
    const fetchLocation = async (search) => {
        if (!search) {
            setLocationSuggestions([]);
            return;
        }
        setLoading(true);
        try {
            const response = await API.get(`/autocomplete/locations?query=${search}`);
            const locationList = Array.isArray(response) ? response : [];
            setLocationSuggestions(locationList);
        } catch (error) {
            console.error("Error fetching locations:", error);
            setLocationSuggestions([]);
        } finally {
            setLoading(false);
        }
    };
    // Send OTP
    const sendOTP = async (phone) => {
        if (isPhoneVerified) {
            setIsPhoneVerified(false);
            return;
        }
        try {
            setLoading(true);
            const phoneNumberWithCode = `${countryCode}${phone}`; // Use selected country code
            const confirmation = await signInWithPhoneNumber(auth, phoneNumberWithCode, window.recaptchaVerifier);
            setConfirmationResult(confirmation);
            setShowOTPModal(true);
            setOtpError("");
        } catch (error) {
            setOtpError("Failed to send OTP. Please try again.");
            console.error("OTP Error:", error);
        } finally {
            setLoading(false);
        }
    };

    // Verify OTP
    const verifyOTP = async () => {
        try {
            setLoading(true);
            await confirmationResult.confirm(otp);
            setShowOTPModal(false);
            setOtp("");
            setIsPhoneVerified(true); // Mark phone as verified
            // Call the new API to update phone and country code
            const payload = {
                phone: phoneNumber,
                countryCode
            };

            const response = await API.put('/user/update-countrycode-phone', payload);

            fetchDataUser(); // Refresh user data
            setPopupData({
                isOpen: true,
                title: "Success!",
                message: "Phone number verified successfully.",
                onConfirm: () => setPopupData({ isOpen: false }),
                onClose: () => setPopupData({ isOpen: false })
            });
            setFormValues(prev => ({ ...prev, phone: phoneNumber, countryCode }));
        } catch (error) {
            setOtpError("Invalid OTP. Please try again.");
            console.error("OTP Verification Error:", error);
        } finally {
            setLoading(false);
        }
    };
    // ✅ Handle Profile Picture Upload
    const handleProfilePicChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileType = file.type;
            const fileSize = file.size;

            if (!["image/png", "image/jpeg", "image/jpg"].includes(fileType)) {
                setImageError("Only PNG, JPG, and JPEG formats are allowed.");
                return;
            }
            if (fileSize > 1024 * 1024) {
                setImageError("File size must be less than 1MB.");
                return;
            }
            setFile(file);

        }
    };
    const dataURLtoFile = (dataUrl, filename) => {
        const arr = dataUrl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    };
    const uploadChangePhoto = async (fileUrl) => {
        const file = dataURLtoFile(fileUrl, 'edited-photo.png');
        setFile(file);
        uploadProfilePic(file);
    };
    const uploadProfilePic = async (file) => {
        if (!file) {  // Check if file is selected
            setImageError("Please select an image.");
            return;
        } else {
            const formData = new FormData();
            formData.append("profile_pic", file);

            const token = localStorage.getItem('jwt_token_jobcritic');

            try {
                const result = await API.post('/user/upload-profile-pic', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Bearer ${token}`, // Token from login
                    },
                });

                // Set profile picture after successful upload
                setProfilePic(URL.createObjectURL(file));
                setImageError(""); // Clear error message
                setShowPopup(false);
                localStorage.removeItem('userData');
                window.location.reload();

            } catch (error) {
                console.error("Upload failed:", error);
                setImageError("Failed to upload image. Please try again.");
            }
        }


    };


    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        setLoading(true);
        try {
            const payload = { name: values.name, phone: values.phone, countryCode: values.countryCode, city_id: values.city, gender: values.gender };//profileTitle: values.profileTitle

            const response = await API.put('/user/update-profile', payload);

            fetchDataUser();
            setPopupData({
                isOpen: true,
                title: "Success!",
                message: "Your details have been updated successfully.",
                onConfirm: () => setPopupData({ isOpen: false }), // Close Popup on Confirm
                onClose: () => setPopupData({ isOpen: false })    // Close Popup on Close
            });

        } catch (error) {
            console.error(" Error submitting form:", error);
        } finally {
            setLoading(false);
            setSubmitting(false);
        }
    };

    const CustomSelect = ({ label, name, options, onChange }) => {
        return (
            <div className="col-md-12 pb-2">
                <label className="block text-sm font-semibold text-gray-600">{label} *</label>
                <div className="relative">
                    <Field
                        as="select"
                        name={name}
                        className="form-control fomc-cls px-3 py-2 w-full appearance-none  border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        onChange={onChange}
                    >
                        <option value="" disabled>
                            Select Gender
                        </option>
                        {options.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </Field>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                        <svg
                            className="w-4 h-4 text-gray-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <ErrorMessage name={name} component="p" className="text-red-500 text-xs mt-1" />
            </div>
        );
    };


    const genderOptions = [

        { value: '1', label: 'Male' },
        { value: '2', label: 'Female' },
        { value: '3', label: 'Other' },
    ];
    const [selectedCountryCodeName, setSelectedCountryCodeName] = useState("");
    return (
        <div className="profile-page">
            <div id="recaptcha-container"></div>
            <MainHeader />
            <section className="pt-[120px] pb-[120px] md:pt-[30px] sm:pt-[30px]">
                <Container>
                    <Row>
                        <Col lg={2} md={12} sm={12}>
                            {/* Profile Picture */}
                            <div className="relative">
                                <div
                                    className=" w-28 h-28 rounded-full overflow-hidden border-4 border-gray-200 cursor-pointer"
                                    onClick={() => setShowPopup(true)}
                                >
                                    <img
                                     crossorigin="anonymous"
                                        src={profilePic || IMAGE_PATHS.USER}
                                        alt="Profile"
                                        className="w-full h-full object-cover"
                                    />

                                </div>
                                <div className="absolute inset-0  flex items-center left-[76px]  text-xs font-bold hover:opacity-100 transition top-[67px] text-center sm:left-[53px]">

                                    <i class="fa-solid fa-camera cursor-pointer" onClick={() => setShowPopup(true)}></i>
                                </div>
                            </div>
                        </Col>

                        <Col lg={10} md={12} sm={12}>
                            {/* ✅ Formik Form with Validation */}
                            <Formik
                                enableReinitialize
                                initialValues={formValues}
                                validationSchema={validationSchema}
                                onSubmit={handleSubmit}
                            >
                                {({ values, handleChange, setFieldValue, handleSubmit, dirty, isValid }) => (
                                    <Form onSubmit={handleSubmit}>
                                        <Col md={12} className="pb-2">
                                            <label className="block text-sm font-semibold text-gray-600">Name</label>
                                            <Field
                                                type="text"
                                                name="name"
                                                placeholder="Enter name..."
                                                className="form-control fomc-cls px-3 py-2"
                                                onChange={handleChange}
                                            />
                                            <ErrorMessage name="name" component="p" className="text-red-500 text-xs mt-1" />
                                        </Col>
                                        {/* <Col md={12} className="pb-2">
                                            <label className="block text-sm font-semibold text-gray-600">Profile Title *</label>
                                            <Field
                                                type="text"
                                                name="profileTitle"
                                                placeholder="Enter profile title..."
                                                className="form-control fomc-cls px-3 py-2"
                                                onChange={handleChange}
                                            />
                                            <ErrorMessage name="profileTitle" component="p" className="text-red-500 text-xs mt-1" />
                                        </Col> */}

                                        <Col md={12} className="pb-2">
                                            <label className="block text-sm font-semibold text-gray-600">Phone Number</label>
                                            <div className="d-flex gap-2 relative ">
                                                <div className="flex w-full">
                                                    {/* Country Code Select */}
                                                    <div className="w-[22%] flex-shrink-0 fds"> {/* Increased width from 11% to 15% */}
                                                        <Select
                                                            name="countryCode"
                                                            options={countryCodeOptions}
                                                            value={countryCodeOptions.find((option) => option.value === values.countryCode && option.label == selectedCountryCodeName) || null}

                                                            onChange={(option) => {
                                                                setCountryCode(option ? option.value : "");
                                                                setTempCountryCode(option ? option.value : "");
                                                                setFieldValue("countryCode", option ? option.value : "");
                                                                // setIsPhoneVerified(
                                                                //     phoneNumber === originalPhone && option?.value === formValues.countryCode
                                                                // );
                                                                setSelectedCountryCodeName(option ? option.label : "");
                                                            }}
                                                            onFocus={() => {
                                                                // Clear selection on focus
                                                                setFieldValue("countryCode", "");
                                                                setCountryCode("");
                                                            }}
                                                            onBlur={() => {
                                                                // Restore previous selection if no new selection was made
                                                                if (!values.countryCode && tempCountryCode) {
                                                                    setFieldValue("countryCode", tempCountryCode);
                                                                    setCountryCode(tempCountryCode);
                                                                }
                                                            }}
                                                            placeholder="Select Country"
                                                            className="react-select-container rounded-r-none border-r-0 fomc-cls custom-select"
                                                            classNamePrefix="react-select"
                                                            aria-label="Select Country Code"
                                                            inputProps={{ autoComplete: "off" }}
                                                            autoComplete="off"
                                                            isDisabled={isPhoneVerified}
                                                            isClearable={false} // Prevent manual clearing to avoid confusion
                                                        />
                                                    </div>

                                                    {/* Phone Input */}
                                                    <Field
                                                        type="text"
                                                        name="phone"
                                                        placeholder="Enter phone..."
                                                        className="form-control flex-grow-1 rounded-l-none !border-l-0 w-[12%] fomc-cls mr-[10px]"
                                                        onChange={(e) => {
                                                            const newPhone = e.target.value;
                                                            setPhoneNumber(newPhone);
                                                            handleChange(e);
                                                            // setIsPhoneVerified(
                                                            //     newPhone === originalPhone && values.countryCode === formValues.countryCode
                                                            // );
                                                        }}
                                                        disabled={isPhoneVerified}
                                                    />

                                                    {/* Verify Button */}
                                                    {/* <Button
                                                        onClick={() => sendOTP(phoneNumber)}
                                                        disabled={phoneNumber.length !== 10 || loading || !values.countryCode}
                                                        className="btn-explore-yellow w-[20%] ml-2"
                                                    >
                                                        {isPhoneVerified ? "Edit" : "Verify"}
                                                    </Button> */}
                                                    <ButtonsVariant
                                                        ariaLabel="button"
                                                        href="#"
                                                        className="mx-[10px] h-max mt-[5px]"
                                                        variant="blackToWhite"
                                                        size="xs"
                                                        title={isPhoneVerified ? "Edit" : "Verify"}
                                                        onClick={() => sendOTP(phoneNumber)}
                                                        disabled={ loading || !values.countryCode}
                                                    />
                                                </div>
                                            </div>
                                            <ErrorMessage name="countryCode" component="p" className="text-red-500 text-xs mt-1" />
                                            <ErrorMessage name="phone" component="p" className="text-red-500 text-xs mt-1" />
                                            {otpError && <p className="text-red-500 text-xs mt-1">{otpError}</p>}
                                            {!isPhoneVerified &&
                                                (phoneNumber !== originalPhone || values.countryCode !== formValues.countryCode) && (
                                                    <p className="text-red-500 text-xs mt-1">Please verify your phone number.</p>
                                                )}
                                        </Col>

                                        <Col md={12} className="pb-2">
                                            <label className="block text-sm font-semibold text-gray-600">Email ID</label>
                                            <Field
                                                type="email"
                                                name="email"
                                                className="form-control fomc-cls px-3 py-2"
                                                placeholder="Enter email..."
                                                disabled
                                            />
                                            {/* <ErrorMessage name="email" component="p" className="text-red-500 text-xs mt-1" /> */}
                                        </Col>
                                        <Col md={12} className="pb-2">
                                            <CustomSelect
                                                label="Gender"
                                                name="gender"
                                                options={genderOptions}
                                                onChange={handleChange}
                                            />
                                            {/* <label className="block text-sm font-semibold text-gray-600">Gender *</label>
                                            <Field
                                                as="select"
                                                name="gender"
                                                className="form-control fomc-cls px-3 py-2"
                                                onChange={handleChange}
                                            >
                                                <option value="0">Select Gender</option>
                                                <option value="1">Male</option>
                                                <option value="2">Female</option>
                                                <option value="3">Other</option>
                                                
                                            </Field>
                                            <ErrorMessage name="gender" component="p" className="text-red-500 text-xs mt-1" /> */}
                                        </Col>

                                        {/* City Input */}
                                        <Col md={12} className="relative ">
                                            <label className="block text-sm font-semibold text-gray-600">Current City *</label>

                                            <div className="relative">
                                                {/* Search Icon inside Input */}
                                                {/* <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer">
                                                    <i className="fas fa-search"></i>
                                                </span> */}

                                                {/* Location Input */}
                                                <Field
                                                    type="text"
                                                    name="city"
                                                    className="form-control fomc-cls  py-2 w-full" // Adjust padding for icon space
                                                    placeholder="Search location..."
                                                    value={locationquery}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setLocationquery(value);
                                                        //setFieldValue("city", value);
                                                        if (value.length > 1) fetchLocation(value);
                                                        else setLocationSuggestions([]);
                                                    }}
                                                    autoComplete="off"
                                                />
                                            </div>

                                            <ErrorMessage name="city" component="p" className="text-red-500 text-xs mt-1" />

                                            {/* City Suggestions */}
                                            {locationsuggestions.length > 0 && (
                                                <ul className="list-group position-absolute w-full mt-1 bg-white shadow-lg rounded z-50">
                                                    {locationsuggestions.map((location) => (
                                                        <li
                                                            key={location.city_id}
                                                            className="list-group-item list-group-item-action cursor-pointer px-3 py-2 hover:bg-gray-100"
                                                            onClick={() => {
                                                                const cityName = `${location.city_name}, ${location.state_name}, ${location.country_name}`;
                                                                setLocationquery(cityName);
                                                                setFieldValue("city", location.city_id);
                                                                setLocationSuggestions([]);
                                                            }}
                                                        >
                                                            {location.city_name}, {location.state_name}, {location.country_name}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </Col>


                                        {/* Buttons */}
                                        <div className="mt-6 flex justify-end gap-4">
                                            <Button
                                                className={` ${!dirty || !isPhoneVerified
                                                    ? "btn-explore-yellow-disabled !border-gray-300 !border-[1px] disabled:!cursor-not-allowed disabled:!bg-gray-300 disabled:opacity-50 disabled:hover:!border-gray-300 disabled:hover:!bg-gray-300 disabled:!text-white disabled:hover:!text-white"
                                                    : "btn-explore-yellow"
                                                    }`}
                                                type="submit"
                                                disabled={!dirty || !isPhoneVerified} // Enable button as soon as form is dirty
                                            >
                                                Save
                                            </Button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </Col>
                    </Row>
                </Container>
                {showPopup && (
                    <ProfilePhotoPopup uploadChangePhoto={uploadChangePhoto} imageSrcVal={profilePic || IMAGE_PATHS.USER} onClose={() => setShowPopup(false)} />
                )}
                {loading ? (
                    <div className="fixed inset-0 flex items-center justify-center bg-gray-100 bg-opacity-50 z-50">
                        <Loader />
                    </div>
                ) : (
                    showOTPModal && (
                        <Modal show={showOTPModal} onHide={() => setShowOTPModal(false)} centered backdrop="static" keyboard={false}>
                            <Modal.Header closeButton>
                                <Modal.Title className="text-black">Verify OTP</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p style={{ color: '#000000' }}>Enter the OTP sent to {countryCode}{phoneNumber}</p>
                                <input
                                    type="text"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                    className="form-control fomc-cls px-3 py-2"
                                    placeholder="Enter OTP"
                                />
                                {otpError && <p className="text-red-500 text-xs mt-1">{otpError}</p>}
                            </Modal.Body>
                            <Modal.Footer className="mt-[10px]">
                              
                                <ButtonsVariant
                                    ariaLabel="button"
                                    onClick={verifyOTP}
                                    disabled={otp.length !== 6 || loading}
                                    href="#"
                                    className="mx-[10px]"
                                    variant="blackToWhite"
                                    size="xs"
                                    title="Verify OTP"
                                />
                            </Modal.Footer>
                        </Modal>
                    )
                )}
            </section>
            {popupData.isOpen && (
                <Confin
                    isOpen={popupData.isOpen}
                    title={popupData.title}
                    message={popupData.message}
                    onClose={() => setPopupData({ isOpen: false })}
                    onConfirm={() => setPopupData({ isOpen: false })}
                    showCancelButton={false}
                    actionType="success"
                />
            )}
            <FooterStyle theme="light" className="bg-black text-[#828282]" />
        </div>
    );
};

export default AccountSettings;
